import { render, staticRenderFns } from "./AudienceGrowthCard.vue?vue&type=template&id=bde83db8&scoped=true"
import script from "./AudienceGrowthCard.vue?vue&type=script&lang=js"
export * from "./AudienceGrowthCard.vue?vue&type=script&lang=js"
import style0 from "./AudienceGrowthCard.vue?vue&type=style&index=0&id=bde83db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde83db8",
  null
  
)

export default component.exports